/**
 * Created by PanJiaChen on 16/11/18.
 */

/**
 * @param {string} path
 * @returns {Boolean}
 */
export function isExternal(path) {
  return new RegExp('^(https?:|mailto:|tel:)').test(path)
}

/**
 * @param {string} str
 * @returns {Boolean}
 */
export function validUsername(str) {
  const valid_map = ['admin', 'editor']
  return valid_map.indexOf(str.trim()) >= 0
}

const phoneReg = new RegExp('^[1][0,1,2,3,4,5,6,7,8,9][0-9]{9}$')
const emailReg = new RegExp('^\\w+([-+.]\\w+)*@\\w+([-.]\\w+)*\\.\\w+([-.]\\w+)*$')
const idCardReg = new RegExp('^[1-9]\\d{5}(?:18|19|20)\\d{2}(?:0[1-9]|10|11|12)(?:0[1-9]|[1-2]\\d|30|31)\\d{3}[\\dXx]$')

const passwordReg = new RegExp('^(?=.*[a-z])(?=.*[A-Z])(?=.*\\d)[a-zA-Z\\d]{8,15}$')
const passwordRegWithSpecial = new RegExp('^(?=.*[a-z])(?=.*[A-Z])(?=.*\\d)(?=.*[$@$!%*?&.])[A-Za-z\\d$@$!%*?&.]{8,15}$')
const nameReg = new RegExp('^([\u2E80-\uFE4F]{1}[\u2E80-\uFE4F\.·。]{0,48}[\u2E80-\uFE4F]{1}|[a-zA-Z\.\s]{1,50})$')

const socialCreditCodeReg = new RegExp('^[0-9A-HJ-NPQRTUWXY]{2}\\d{6}[0-9A-HJ-NPQRTUWXY]{10}$')

const letterAndNumberReg = new RegExp('^[0-9A-Za-z]*$') // 不校验位数

const numberReg = new RegExp('^[0-9]*$')

/**
 * 是否是数字类型
 * @param {number} str
 * @returns {Boolean}
 */
export function isNumber(number) {
  return numberReg.test(number)
}

/**
 * 是否是手机号格式
 * @param {number} str
 * @returns {Boolean}
 */
export function isPhoneNo(phoneNo) {
  return phoneReg.test(phoneNo)
}

/**
 * 是否是邮箱格式
 * @param {String} str
 * @returns {Boolean}
 */
export function isEmail(email) {
  return emailReg.test(email)
}

/**
 * 是否是姓名格式
 * @param {String} str
 * @returns {Boolean}
 */
export function isName(name) {
  return nameReg.test(name)
}

/**
 * 是否是身份证格式
 * @param {String} str
 * @returns {Boolean}
 */
export function isIdCard(str) {
  console.log(idCardReg.test(str))
  return idCardReg.test(str)
}

/**
 * 是否是密码格式 至少8个字符，至少1个大写字母，1个小写字母和1个数字：
 * @param {String} str
 * @returns {Boolean}
 */
export function isPassword(str) {
  return passwordReg.test(str) || passwordRegWithSpecial.test(str)
}

/**
 * 是否是社会统一信用代码
 * @param {number} str
 * @returns {Boolean}
 */
export function isSocialCreditCode(code) {
  return socialCreditCodeReg.test(code)
}

/**
 * 备案编号，不校验位数
 * @param {number} str
 * @returns {Boolean}
 */
export function isFillingCode(code) {
  return letterAndNumberReg.test(code)
}

export function validateNumInput(val, num = 4) {
  var str = val
  var len1 = str.substr(0, 1)
  var len2 = str.substr(1, 1)
  // 如果第一位是0，第二位不是点，就用数字把点替换掉
  if (str.length > 1 && (+len1 === 0) && len2 !== '.') {
    str = str.substr(1, 1)
    console.log(str)
  }
  // 第一位不能是.
  if (len1 === '.') {
    str = ''
  }
  // 限制只能输入一个小数点
  if (str.indexOf('.') !== -1) {
    var str_ = str.substr(str.indexOf('.') + 1)
    if (str_.indexOf('.') !== -1) {
      str = str.substr(0, str.indexOf('.') + str_.indexOf('.') + 1)
    }
    // 保留小数点后几位
    if (str_.length > num) {
      str = str.substr(0, str.indexOf('.') + (num + 1))
      console.log(str)
    }
  }
  // 正则替换，保留数字和小数点
  str = str.replace(new RegExp('[^\\d.]+', 'g'), '')
  return str
}

